import { render, staticRenderFns } from "./PrescriptionTempV2.vue?vue&type=template&id=a5819e6e"
import script from "./PrescriptionTempV2.vue?vue&type=script&lang=js"
export * from "./PrescriptionTempV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports